/**
 * A simple timer implementation
 */
import TTLProxy from "./TTLAsyncProxy";

class ReactTimer {

    isRunning = false;

    interval;

    onTick  = null;

    _timerHandle = null;

    constructor(tickEvent ,  interval){
        this.onTick = tickEvent;
        this.interval = interval;
    }

    _nextTick(output){

        //  return false to stop
        if(output === false || !TTLProxy.getInstance().isAuthenticated()) {
            this.isRunning = false;
            return;
        }

        this._timerHandle = window.setTimeout(this._handleTimerTick.bind(this) , this.interval);
    }

    _handleTimerTick(){

        let output = this.onTick();

        if(output instanceof Promise){
            output.then(v => this._nextTick(v)).catch(err => this._nextTick(err));
        }
        else {
            this._nextTick(output);
        }

    }

    setInterval(interval){

        //  stop
        this.stop();

        //  set interval
        this.interval = interval;

        //  start timer
        this.start();

    }

    stop(){

        if(this._timerHandle) {
            window.clearTimeout(this._timerHandle);
            this.isRunning = false;
        }

    }


    start(immediate){

        if(!this.isRunning){

            if(immediate){
                this._handleTimerTick();
            }

            this._timerHandle = window.setTimeout(this._handleTimerTick.bind(this), this.interval);
            this.isRunning = true;
        }

    }

}

export default ReactTimer;


// WEBPACK FOOTER //
// ./src/common/ReactTimer.js